(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/history-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/history-suspension.js');
'use strict';

const {
  TableRow,
  TableCell
} = svs.ui.reactTable;
const {
  getProductText,
  getSuspensionTypeText
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper;
const HistorySuspension = _ref => {
  let {
    suspension
  } = _ref;
  return React.createElement(TableRow, null, React.createElement(TableCell, null, getProductText(suspension.product, suspension.type, true, false)), React.createElement(TableCell, null, getSuspensionTypeText(suspension.period, suspension.terminationPeriod)), React.createElement(TableCell, {
    className: "right"
  }, svs.utils.date.FormatTime('d/M, yyyy', suspension.validFrom), ' ', "-", ' ', svs.utils.date.FormatTime('d/M, yyyy', suspension.ended)));
};
svs.spelpaus.pages.svsSuspension.components.HistorySuspension = HistorySuspension;

 })(window);